import { IExportCalculatorSettings } from 'types';
import { appConfig } from '../config/app';
import { ApiClient } from './ApiClient';

export const DataImport = {
  siteCalculatorSettings: (siteId: string, body: IExportCalculatorSettings) => ApiClient.put(`${appConfig.API_BASE_URL}/v1/import/sites/${siteId}/calculator/settings`, body),
};
